import { useCallback } from "react";

export const useFlattenSubGroups = () => {
    const extractAttributes = (attributeGroups) => {
        return attributeGroups.reduce((attributes, group) => {
            if (group.subGroups.length) {
                const nestedAttributes = extractAttributes(group.subGroups);

                attributes = [...attributes, ...nestedAttributes];
            }

            if (group.attributes && group.attributes.length) {
                attributes = [...attributes, ...group.attributes];
            }

            return attributes;
        }, []);
    };

    return useCallback(extractAttributes, []);
};
